import { DialogOptions } from 'components/core/Dialog/common/Dialog';
import { AsyncDialogOptions } from 'components/core/Dialog/common/useAsyncDialog';
import React from 'react';
import { FormattedMessage, formatTranslation } from 'intl';
import { DialogTranslationKeys } from 'intl/keys';
import { IntlShape, useIntl } from 'react-intl';
import { SelectedItemBreakdown } from 'shared/domain/documentation/operationPreflight';
import { CommonTranslationKeys, DocumentationTranslationKeys } from 'intl/keys';

function renderBreakdownList(
  breakdown: SelectedItemBreakdown[],
  intl: IntlShape
): React.ReactNode[] {
  return breakdown.map((item, index) => {
    const isLast = index === breakdown.length - 1;
    const separator = isLast ? '' : ', ';

    if (item.type === 'directory') {
      const countSuffix = formatTranslation(
        intl,
        DocumentationTranslationKeys.itemFolderCountSuffix,
        { count: item.nestedCount }
      );

      return (
        <React.Fragment key={item.localId}>
          <strong>{item.name}</strong> {countSuffix}{separator}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment key={item.localId}>
        <strong>{item.name}</strong>{separator}
      </React.Fragment>
    );
  });
}

function BreakdownDescription({
  breakdown,
}: {
  breakdown: SelectedItemBreakdown[];
}): React.ReactElement {
  const intl = useIntl();
  const itemsList = renderBreakdownList(breakdown, intl);

  return (
    <FormattedMessage id={DialogTranslationKeys.confirmationDeleteDocumentationBreakdown}
      values={{
        itemsList: <>{itemsList}</>,
      }}
    />
  );
}

export function documentationDeleteDialog(
  selectedCount: number,
  breakdown?: SelectedItemBreakdown[]
): DialogOptions {
  const hasBreakdown = breakdown && breakdown.length > 0;

  return {
    catchOnCancel: false,
    title: (
      <FormattedMessage id={DialogTranslationKeys.confirmationDeleteDocumentationTitle} />
    ),
    description: (
      <span>
        {hasBreakdown ? (
          <BreakdownDescription breakdown={breakdown} />
        ) : (
          <FormattedMessage id={DialogTranslationKeys.confirmationDeleteDocumentation}
            values={{ selectedCount }}
          />
        )}
      </span>
    ),
  };
}

export function documentationDeleteAsyncDialog(
  selectedCount: number,
  breakdown?: SelectedItemBreakdown[]
): AsyncDialogOptions {
  const hasBreakdown = breakdown && breakdown.length > 0;

  return {
    title: (
      <FormattedMessage id={DialogTranslationKeys.confirmationDeleteDocumentationTitle} />
    ),
    description: (
      <span>
        {hasBreakdown ? (
          <BreakdownDescription breakdown={breakdown} />
        ) : (
          <FormattedMessage id={DialogTranslationKeys.confirmationDeleteDocumentation}
            values={{ selectedCount }}
          />
        )}
      </span>
    ),
    submitLabel: CommonTranslationKeys.archive,
  };
}
